import React, { useState } from 'react';
import './SupplementTableRow.scss';
import { Supplement } from '../../../../api/supplements';
import { getFullImageUrl } from '../../../../utils/constants';
import TableRowActionMenu from '../../../BaseComponents/TableRowActionMenu';

interface Props {
  supplementData: Supplement;
  onEdit: () => void;
}

const SupplementTableRow: React.FC<Props> = ({ supplementData, onEdit }) => {
  const [imageError, setImageError] = useState<boolean>(false);
  
  const truncateText = (text: string, maxLength: number) => {
    if (!text) return '-';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  };

  const handleRowClick = () => {
    onEdit();
  };

  const onOptionClick = (_: string, action: string) => {
    if (action === 'edit') {
      onEdit();
    }
  };

  const handleImageError = () => {
    setImageError(true);
  };

  const getImageSrc = () => {
    if (imageError || !supplementData.image) {
      return getFullImageUrl('supplement-placeholder.png');
    }
    return getFullImageUrl(supplementData.image);
  };

  return (
    <div className="supplement-row" onClick={handleRowClick}>
        <div className='image'>
          <img 
            src={getImageSrc()} 
            width="80" 
            height="80"
            alt={supplementData.supplement_name || 'Supplement'}
            onError={handleImageError}
          />
        </div>

      <div className='name'>
        {supplementData.supplement_name || 'No Name'}
      </div>

      <div className='description'>
        {truncateText(supplementData.description || 'No description available', 150)}
      </div>

      <div className='actions'>
        <TableRowActionMenu
          options={[
            { key: 'edit', value: 'Edit/View' }
          ]}
          id={supplementData.id || supplementData.supplement_id}
          onActionMenuClick={onOptionClick}
        />
      </div>
    </div>
  );
};

export default SupplementTableRow;
